import React from 'react';
import { SortButton } from '../../../../search/components/sort';
import { SearchProps } from '../../models/arc-epi-props';



interface EmployeeListLabelsProps {
	settings: SearchProps,
}

export const EmployeeListLabels = (props: EmployeeListLabelsProps) => {

	return (
		<div className='employee-search-table-row employee-search-table-sort-row'>
			<div className='employee-search-table-row-cell'>
				<SortButton label={props.settings?.clientNumberLabel} name='masked_client_number' />
			</div>
			<div className='employee-search-table-row-cell icon-row-title'>
				<SortButton label={props.settings?.nameLabel} name='last_name' />
			</div>
			<div className='employee-search-table-row-cell'>
				<SortButton label={props.settings?.addressLabel} name='fullAddress' />
			</div>
			<div className='employee-search-table-row-cell'>
				<SortButton label={props.settings?.employmentTypeLabel} name='employmentType' />
			</div>
			<div className='employee-search-table-row-cell'>
				<p><strong>{props.settings?.statusLabel}</strong></p>
			</div>
			<div className='employee-search-table-row-cell'>
				<p><strong>{props.settings?.actionLabel}</strong></p>
			</div>
		</div>
	);

};